module.exports = __webpack_public_path__ + "img/GraphicDesign.13c9dc84.svg";